import { PlusOutlined, PrinterOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Form, Input, Row, Space, Table, Tooltip, Select, message, Spin } from 'antd';
import Plug from '../../Images/Plug.png';
import Stopcircle from '../../Images/Stopcircle.png';
import printWindow from '../../Images/printWindow.png';
import Playcircle from '../../Images/Playcircle.png';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-phone-input-2/lib/style.css';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { resetWorkOrderList, fetchWorkOrderItemById } from '../../slices/work-order';
import { debounce } from 'lodash';
import {
  resetWorkOrderListInBundleInward,
  fetchWorkOrderListInBundleInward,
  fetchBundleInWardListByItem,
  createBundleInWard,
  fetchBundleInWardByWorkorderItem,
  shiftBundleExcessStock,
} from '../../slices/bundleinword';
import { fetchjobWorkList } from '../../slices/job-work';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);

const { Option } = Select;

export default function AddBundleInWard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { workorderlist: workOrderList = [], status } = useSelector(state => state.bundleInWard);
  const [workOrderPage, setWorkOrderPage] = useState(1);
  const [workOrderHasMore, setWorkOrderHasMore] = useState(true);
  const [workOrderFetching, setWorkOrderFetching] = useState(false);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [workOrderSearch, setWorkOrderSearch] = useState('');
  const [workOrderInputValue, setWorkOrderInputValue] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(20);

  const [packingType, setPackingType] = useState([]);
  const [surfaceFinishType, setSurfaceFinishType] = useState([]);
  const [selectedWorkOrderBundles, setSelectedWorkOrderBundles] = useState([]);
  const checkedList = ([
    'SrNo',
    'bundle_no',
    'die_profile',
    'length',
    'workorder_detail',
    'pieces',
    'weight',
    'avg',
    'avg_weight',
    'packing_date',
    'status',
    'customer',
    'action',
  ]);

  // Reset work orders when search changes
  const getCurrentShift = () => {
    const now = dayjs().tz('Asia/Kolkata');

    const startA = now.set('hour', 8).set('minute', 0).set('second', 0);   // 08:00 AM
    const endA = now.set('hour', 20).set('minute', 0).set('second', 0);   // 08:00 PM

    if (now.isSameOrAfter(startA) && now.isBefore(endA)) {
      return 'A';
    }

    return 'B';
  };

  useEffect(() => {
    const currentShift = getCurrentShift();
    form.setFieldsValue({
      shift: currentShift, // for example
    });
  }, [form]);


  const loadWorkOrders = async (page) => {
    if (workOrderFetching || !workOrderHasMore) return;

    setWorkOrderFetching(true);

    const response = await dispatch(
      fetchWorkOrderListInBundleInward({
        page,
        pagesize: 20,
        ...(workOrderSearch ? { search: workOrderSearch } : {}),
        ...(orderBy && { ordering: orderBy }),
      })
    );
    console.log(response?.payload);
    if (response?.payload?.next === null) {
      console.log("no more data");
      setWorkOrderHasMore(false);
    }

    setWorkOrderPage(prev => prev + 1);
    setWorkOrderFetching(false);
  };

  const handleDropdownScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 10) {
      loadWorkOrders(workOrderPage);
    }
  };

  const handleFinish = values => {
    setBtnLoading(true);
    dispatch(createBundleInWard({ values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        message.success('Bundle InWard Created Successfully!');

        let printId = undefined;
        if (result && result.id) {
          printId = result.id;
        } else if (result && result.data && result.data.id) {
          printId = result.data.id;
        } else if (Array.isArray(result) && result[0] && result[0].id) {
          printId = result[0].id;
        }
        if (printId) {
          handlePartyPrint({ id: printId });
        } else {
          console.error('Could not find bundle id for printing:', result);
        }
        const workorderValue = form.getFieldValue('workorder');
        const workorderItemValue = form.getFieldValue('workorder_detail');
        form.resetFields(['pieces', 'hardness', 'weight', 'gross_weight', 'remarks']);
        form.setFieldsValue({
          workorder: workorderValue,
          workorder_detail: workorderItemValue
        });
        handleWorkOrderSelect(workorderValue)
          .then(() => {
            if (workorderItemValue) {
              handleWorkOrderSelectItem(workorderItemValue, workorderValue);
            }
          });
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const [workOrderItem, setWorkOrderItem] = useState([]);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState(null);
  const [workOrderStats, setWorkOrderStats] = useState({
    orderPcs: 0,
    orderKg: 0,
    dispatchedPcs: 0,
    dispatchedKg: 0,
    packedPcs: 0,
    packedKg: 0,
    pendingPcs: 0,
    pendingKg: 0,
  });

  const handleWorkOrderSelect = async workOrderId => {
    const selectedWorkOrder = workOrderList.find(wo => wo.id === workOrderId);

    setPackingType(selectedWorkOrder?.packing_mode_details || []);
    setSelectedWorkOrder(selectedWorkOrder);
    form.setFieldsValue({
      orderPcs: null,
      pendingKg: null,
      pendingPcs: null,
      packedPcs: null,
      packedKg: null,
      dispatchedKg: null,
      dispatchedPcs: null,
      orderKg: null
    });
    setSelectedWorkOrderId(workOrderId);

    try {
      const response = await dispatch(
        fetchWorkOrderItemById({
          id: workOrderId,
          page: 1,
          pagesize: 200,
        }),
      );

      if (Array.isArray(response.payload)) {
        setWorkOrderItem(response.payload);
      } else {
        setWorkOrderItem([]);
      }
    } catch (error) {
      console.error('Error fetching work order items:', error);
      setWorkOrderItem([]);
    }

    const response = await dispatch(
      fetchBundleInWardListByItem({
        page: 1,
        pagesize: 1000,
        workOrderId,
      }),
    ).unwrap();
    setWorkOrderStats({
      orderPcs: response.data.order?.pieces || 0,
      orderKg: response.data.order?.weight || 0,
      dispatchedPcs: response.data.dispatched?.pieces || 0,
      dispatchedKg: response.data.dispatched?.weight || 0,
      packedPcs: response.data.packed?.pieces || 0,
      packedKg: response.data.packed?.weight || 0,
      pendingPcs: response.data.pending?.pieces || 0,
      pendingKg: response.data.pending?.weight || 0,
    });
    const transformedData = response.data.bundles.map((item, index) => ({
      ...item,
      SrNo: index + 1,
    }));
    setSelectedWorkOrderBundles(transformedData);
  };

  const handleWorkOrderSelectItem = async (selectedId, workOrderId) => {
    const selectedItem = workOrderItem.find(item => item.id === selectedId);
    form.setFieldsValue({ pieces: undefined, weight: undefined });
    if (selectedItem) {
      const surfaceFinish = selectedItem?.jobworks;
      if (surfaceFinish) {
        const response = await dispatch(fetchjobWorkList());
        const jobWorks = response?.payload?.results?.data || [];

        // ensure both are numbers
        const jobWork = jobWorks.find(j => j.id === Number(surfaceFinish));

        if (jobWork) {
          const surfaceFinishName = jobWork.name;
          setSurfaceFinishType(surfaceFinishName);
        } else {
          console.warn("No jobwork found for ID:", surfaceFinish);
        }

        const responsetwo = await dispatch(
          fetchBundleInWardByWorkorderItem({
            page: 1,
            pagesize: 1000,
            selectedId,
          }),
        ).unwrap();
        setWorkOrderStats({
          orderPcs: responsetwo.data.order?.pieces || 0,
          orderKg: responsetwo.data.order?.weight || 0,
          dispatchedPcs: responsetwo.data.dispatched?.pieces || 0,
          dispatchedKg: responsetwo.data.dispatched?.weight || 0,
          packedPcs: responsetwo.data.packed?.pieces || 0,
          packedKg: responsetwo.data.packed?.weight || 0,
          pendingPcs: responsetwo.data.pending?.pieces || 0,
          pendingKg: responsetwo.data.pending?.weight || 0,
        });
        const transformedData = responsetwo.data.bundles.map((item, index) => ({
          ...item,
          SrNo: index + 1,
        }));
        setSelectedWorkOrderBundles(transformedData);
      } else {
        setSurfaceFinishType('N/A');
      }
    } else {
      setSurfaceFinishType('N/A');
    }
  };

  const handleShiftBundleExcessStock = bundleId => {
    const values = {
      bundle_id: [bundleId],
    };
    dispatch(shiftBundleExcessStock({ values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        message.success('Bundle Shifted To Excess Stock Successfully!');
        const selectedWorkOrderId = form.getFieldValue('workorder');
        const selectedWorkOrderItemId = form.getFieldValue('workorder_detail');

        try {
          const isItemIdEmpty =
            selectedWorkOrderItemId === null ||
            selectedWorkOrderItemId === undefined ||
            (Array.isArray(selectedWorkOrderItemId) &&
              selectedWorkOrderItemId.length === 0);
          if (selectedWorkOrderId && isItemIdEmpty) {
            handleWorkOrderSelect(selectedWorkOrderId);
          } else if (selectedWorkOrderId && selectedWorkOrderItemId) {
            handleWorkOrderSelectItem(
              selectedWorkOrderItemId,
              selectedWorkOrderId,
            );
          }
        } catch (error) {
          console.error('Error while refreshing work order selection:', error);
          message.error('Something went wrong while refreshing data.');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };

  const debouncedWorkOrderSearch = useMemo(() => debounce((value) => {
    setWorkOrderSearch(value);
    setWorkOrderPage(1);
    setWorkOrderHasMore(true);
  }, 500), []); // 300ms delay for work order search


  const handleWorkOrderSearch = useCallback((value) => {
    setWorkOrderInputValue(value);
    debouncedWorkOrderSearch(value);
  }, [debouncedWorkOrderSearch]);

  useEffect(() => {
    setWorkOrderPage(1);
    setWorkOrderHasMore(true);
    dispatch(resetWorkOrderListInBundleInward());
    loadWorkOrders(1);
  }, [workOrderSearch]);

  const workOrder = (
    <Form.Item
      name="workorder"
      label="Select Work Order"
      rules={[{ required: true, message: 'Please Select Work Order!' }]}
    >
      <Select
        placeholder="Order Date - Order No - PO Number - PO Date - Customer Name"
        onChange={handleWorkOrderSelect}
        onPopupScroll={handleDropdownScroll}
        onSearch={handleWorkOrderSearch}
        searchValue={workOrderInputValue}
        showSearch
        filterOption={false}
        style={{ width: '100%' }}
        optionLabelProp="label"
        notFoundContent={
          workOrderFetching || status !== 'succeeded' ? (
            <div style={{ textAlign: 'center' }}>
              <Spin size="small" />
            </div>
          ) : workOrderList.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '8px' }}>
              No work orders found
            </div>
          ) : null
        }
        loading={workOrderFetching || status !== 'succeeded'}
      >
        {workOrderList?.map(wo => (
          <Option
            key={wo.id}
            value={wo.id}

            label={`${dayjs(wo?.order_date).format('DD/MM/YYYY')} - ${wo?.order_no} | ${wo?.purchase_order_no} - ${dayjs(wo?.purchase_order_date).format('DD/MM/YYYY')} | ${wo?.customer?.customer_name}`}
            disabled={!['Open', 'W/o create', 'Planning'].includes(wo?.status)}
          >

            <div
              title={`${wo?.order_date} - ${wo?.order_no} | ${wo?.purchase_order_no} - ${wo?.purchase_order_date} | ${wo?.customer?.customer_name}`}
              style={{
                padding: '4px 0',
                lineHeight: '1.4'
              }}
            >
              <div style={{ fontWeight: 'bold' }}>
                {dayjs(wo?.order_date).format('DD/MM/YYYY')} | {wo?.order_no}
              </div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                PO No.: {wo?.purchase_order_no} | PO Date: {dayjs(wo?.purchase_order_date).format('DD/MM/YYYY')}
              </div>
              <div style={{ fontSize: '12px', color: '#333', fontWeight: '500' }}>
                {wo?.customer?.customer_name}
              </div>
            </div>
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
  const workOrderFormItem = (
    <Form.Item
      name="workorder_detail"
      label="Work Order Item"
      rules={[{ required: true, message: 'Please Select Work Order!' }]}
    >
      <Select
        placeholder="Select Work Order"
        onChange={handleWorkOrderSelectItem}
        showSearch
        optionFilterProp="children"
        style={{ width: '100%' }}
        filterOption={(input, option) => {
          const label = option.children
            ? option.children.toString().replace(/\s+/g, '').toLowerCase()
            : '';
          const search = input.replace(/\s+/g, '').toLowerCase();
          return label.includes(search);
        }}
      >
        {Array.isArray(workOrderItem) && workOrderItem.length > 0 ? (
          workOrderItem.map(wo => (
            <Option
              key={wo.id}
              value={wo.id}
              disabled={wo.status === 'Packed' || wo.status === 'Dispatched'}
              style={{ backgroundColor: wo.die_over_weight ? "orange" : "" }}

            >
              {`${wo.die_profile?.die_number || 'N/A'} - ${wo.length || 'N/A'} mm - 
                         Packed: ${wo.packed_weight || '0.000'} kg - Dispatched: ${wo.dispatched_weight || '0.000'} kg - 
                         Net Order: ${wo.net_weight || '0.000'} kg - Temper: ${wo.temper?.temper_code_new || 'N/A'} - 
                         Code: ${wo.temper?.temper_code_old || 'N/A'}`}
            </Option>
          ))
        ) : (
          <Option disabled>No items found</Option>
        )}
      </Select>
    </Form.Item>
  );

  const [shiftmode, setShiftMode] = useState(false);

  const shiftModes = ([
    { title: 'A', value: 'A' },
    { title: 'B', value: 'B' },
  ]);

  const handleChangeShift = e => {
    setShiftMode(e);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'pan_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'pan_number';
    }
    if (sortField === 'pan_number' && sortOrder === 'descend') {
      sortingEnumKey = '-pan_number';
    }
    if (sortField === 'gstin_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'gstin_number';
    }
    if (sortField === 'gstin_number' && sortOrder === 'descend') {
      sortingEnumKey = '-gstin_number';
    }
    if (sortField === 'udyam_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'udyam_no';
    }
    if (sortField === 'udyam_no' && sortOrder === 'descend') {
      sortingEnumKey = '-udyam_no';
    }
    if (sortField === 'customer_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer_name';
    }
    if (sortField === 'customer_name' && sortOrder === 'descend') {
      sortingEnumKey = '-customer_name';
    }
    if (sortField === 'phone_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'phone_number';
    }
    if (sortField === 'phone_number' && sortOrder === 'descend') {
      sortingEnumKey = '-phone_number';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by';
    }
    return sortingEnumKey;
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    setPageSize(pagination.pageSize);
  };
  const handlePartyPrint = data => {
    window.open(`/add-inward-party-print/${data.id}`, '_blank');
  };
  const handlePrint = data => {
    window.open(`/add-inward-print/${data.id}`, '_blank');
  };
  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo', // Use a unique key for the serial number
      key: 'SrNo',

      width: '100px',
    },
    {
      title: 'Bundle No',
      dataIndex: 'bundle_no',
      key: 'bundle_no',
      width: '200px',
    },
    {
      title: 'Profile',
      dataIndex: 'die_number',
      key: 'die_profile',
      render: (die_number) => {
        return (
          <span>
            {die_number || 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Length(mm)',
      dataIndex: 'length',
      key: 'length',
      width: '200px',
      render: (length) => {
        return <span>{length || 'N/A'}</span>;
      },
    },
    {
      title: 'Profile Description',
      dataIndex: 'dimensions',
      key: 'workorder_detail',
      render: (dimensions) => {
        return <span>{dimensions || 'N/A'}</span>;
      },
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
      width: '200px',
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      width: '200px',
      key: 'weight',
    },
    {
      title: 'Avg Wt(kg)',
      dataIndex: 'avg_weight',
      width: '200px',
      key: 'avg_weight',
      render: record => {
        return <span>{record ? record : 0.0} </span>;
      },
    },
    {
      title: 'Packing Date',
      dataIndex: 'packing_date',
      width: '200px',
      key: 'packing_date',
      render: record => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY') : 'N/A'} </span>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '200px',
      key: 'status',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      render: record => {
        return (
          <span>
            {record ? `${record.first_name} ${record.last_name}` : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',

      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      render: record => {
        return (
          <span>
            {record && record.first_name?.trim() && record.last_name?.trim()
              ? `${record.first_name} ${record.last_name}`
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tooltip placement="top" title={'Party Print'}>
            <span onClick={() => handlePartyPrint(record)}>
              <img
                src={printWindow}
                width={'20px'}
                height={'20px'}
                alt=""
              ></img>
            </span>
          </Tooltip>

          <Tooltip placement="top" title={'Shift Bundle To Excess Stock'}>
            <span onClick={() => handleShiftBundleExcessStock(record?.id)}>
              <UploadOutlined style={{ cursor: 'pointer' }} />
            </span>
          </Tooltip>

          <Tooltip placement="top" title={'Print'}>
            <span onClick={() => handlePrint(record)}>
              <PrinterOutlined style={{ cursor: 'pointer' }} />
            </span>
          </Tooltip>
        </Space>
      ),
    },
  ];
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  /* Weight Reading */
  const [port, setPort] = useState(null);
  const [reading, setReading] = useState(false);

  const connectSerial = async () => {
    try {
      const selectedPort = await navigator.serial.requestPort();
      await selectedPort.open({ baudRate: 9600 });
      setPort(selectedPort);
    } catch (error) {
      console.error('Connection failed:', error);
    }
  };

  const startReading = async () => {
    if (!port) return;

    const textDecoder = new TextDecoderStream();
    const reader = textDecoder.readable.getReader();

    setReading(true);

    try {
      while (reading) {
        const { done } = await reader.read();
        if (done) break;
      }
    } catch (err) {
      console.error('Read error:', err);
    } finally {
      reader.releaseLock();
    }
  };

  const stopReading = () => {
    setReading(false);
    if (port) {
      port.close();
      setPort(null);
    }
  };

  return (
    <>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-3"
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Add New Packed Bundle</h2>
              <div className="bredcrumbwrp">
                <Link onClick={() => navigate(-1)} className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to="/bundle-inward">Pack Bundle</Link> },
                    { title: 'Add New Packed Bundle' },
                  ]}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="formwrapper">
        <Row gutter={24}>
          <Col xs={24} xl={6}>
            <Form layout="vertical" form={form} onFinish={handleFinish}>
              <Row gutter={16}>
                <Col xs={12} sm={8} xl={24} xxl={24}>
                  {workOrder}
                </Col>
                <Col xs={12} sm={8} xl={24} xxl={24}>
                  {workOrderFormItem}
                </Col>

                <Col xs={12} sm={8} xl={24} xxl={12}>
                  <Form.Item
                    name="pieces"
                    label="Pieces"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter a valid pieces',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter pieces"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({ pieces: formattedValue }); // Update Form state
                      }}
                      maxLength={10}
                      onKeyPress={e => {
                        if (!/^[0-9]+$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={8} xl={24} xxl={12}>
                  <Form.Item
                    name="hardness"
                    label="Hardness Value"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid hardness value',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter hardness value"
                      maxLength={10}

                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({ hardness: formattedValue }); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={12} sm={8} xl={24} xxl={12}>
                  <Form.Item
                    name="weight"
                    label="Weight"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid weight',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter weight value"
                      maxLength={10}

                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({ weight: formattedValue }); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={8} xl={24} xxl={12}>
                  <div
                    style={{
                      display: 'flex',
                      gap: '0px',
                      marginTop: '24px',
                      marginBottom: '16px',
                      marginLeft: '6px',
                      alignItems: 'center',
                    }}
                  >
                    <Tooltip title="Connect">
                      <Button type="link" onClick={connectSerial} >
                        <img
                          className="widhout-collapsed-logo"
                          src={Plug}
                          width={'20px'}
                          height={'20px'}
                          alt="Connection"
                          onClick={stopReading}
                        />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Stop">
                      <Button type="link" onClick={stopReading} >
                        <img
                          className="widhout-collapsed-logo"
                          src={Stopcircle}
                          width={'20px'}
                          height={'20px'}
                          alt="Stop Reading"
                          onClick={stopReading}
                        /></Button>
                    </Tooltip>
                    <Tooltip title="Start">
                      <Button type="link" onClick={startReading} >
                        <img
                          className="widhout-collapsed-logo"
                          src={Playcircle}
                          width={'20px'}
                          height={'20px'}
                          alt="Reading Weight"
                        /></Button>
                    </Tooltip>
                  </div>
                </Col>

                <Col xs={12} sm={8} xl={24} xxl={12}>
                  <Form.Item
                    name="gross_weight"
                    label="Gross Weight"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter valid gross weight',
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter gross weight value"
                      maxLength={10}

                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({ gross_weight: formattedValue }); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={12} sm={8} xl={24} xxl={12}>
                  <Form.Item
                    name="shift"
                    label="Shift"
                    rules={[{ required: true, message: 'Please select shift' }]}
                  >
                    <Select
                      disabled
                      placeholder="Select Shift"
                      onChange={handleChangeShift}
                      options={shiftModes}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} className="leftlblvalue">
                  <label>Work Order Remarks :</label>
                  {selectedWorkOrder?.remarks || 'N/A'}
                </Col>
                <Col xs={24} className="leftlblvalue">
                  <label>Packing Type :</label>
                  <p>
                    {packingType?.map(item => item.name).join(", ")}
                  </p>
                </Col>
                <Col xs={24} className="leftlblvalue">
                  <label>Surface Finish :</label>
                  {surfaceFinishType || 'N/A'}
                </Col>
                <Col xs={24}>
                  <Form.Item
                    name="remarks"
                    label="Remarks"
                    style={{ marginLeft: '3px', marginTop: '10px' }}
                  >
                    <Input.TextArea
                      placeholder="Enter Remarks"
                      onChange={e => {
                        const value = e.target.value;
                        const formattedValue = value
                          .toLowerCase()
                          .replace(/\b\w/g, char => char.toUpperCase());
                        form.setFieldsValue({ remarks: formattedValue }); // Update Form state
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="flex justify-end mb-3">
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<PlusOutlined />}
                  loading={btnLoading}
                  disabled={btnLoading}
                >
                  Add Bundle
                </Button>
              </div>
            </Form>
          </Col>

          <Col xs={24} xl={18}>
            <Row gutter={24}>
              <Col xs={24} md={12} lg={6}>
                <div className="widwrp" style={{ backgroundColor: '#e0f2f7' }}>
                  <div className="widtitle">Order</div>
                  <div className="vidvaluerow">
                    <div>
                      <label style={{ fontSize: '1.3rem' }}>Pcs</label>
                      <span
                        style={{
                          fontSize: '1.5rem',
                          wordBreak: 'break-all',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        {workOrderStats.orderPcs}
                      </span>
                    </div>
                    <div>
                      <label style={{ fontSize: '1.3rem' }}>Kg</label>
                      <span
                        style={{
                          fontSize: '1.5rem',
                          wordBreak: 'break-all',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        {workOrderStats.orderKg}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <div className="widwrp" style={{ backgroundColor: '#e0f8e0' }}>
                  <div className="widtitle">Dispatched</div>
                  <div className="vidvaluerow">
                    <div>
                      <label style={{ fontSize: '1.3rem' }}>Pcs</label>
                      <span
                        style={{
                          fontSize: '1.5rem',
                          wordBreak: 'break-all',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        {workOrderStats.dispatchedPcs}
                      </span>
                    </div>
                    <div>
                      <label style={{ fontSize: '1.3rem' }}>Kg</label>
                      <span
                        style={{
                          fontSize: '1.5rem',
                          wordBreak: 'break-all',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        {workOrderStats.dispatchedKg}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <div className="widwrp" style={{ backgroundColor: '#FFFBF6' }}>
                  <div className="widtitle">Packed</div>
                  <div className="vidvaluerow">
                    <div>
                      <label style={{ fontSize: '1.3rem' }}>Pcs</label>
                      <span
                        style={{
                          fontSize: '1.5rem',
                          wordBreak: 'break-all',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        {workOrderStats.packedPcs}
                      </span>
                    </div>
                    <div>
                      <label style={{ fontSize: '1.3rem' }}>Kg</label>
                      <span
                        style={{
                          fontSize: '1.5rem',
                          wordBreak: 'break-all',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        {workOrderStats.packedKg}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <div className="widwrp" style={{ backgroundColor: '#F7F6FF' }}>
                  <div className="widtitle">Pending</div>
                  <div className="vidvaluerow">
                    <div>
                      <label style={{ fontSize: '1.3rem' }}>Pcs</label>
                      <span
                        style={{
                          fontSize: '1.5rem',
                          wordBreak: 'break-all',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        {workOrderStats.pendingPcs}
                      </span>
                    </div>
                    <div>
                      <label style={{ fontSize: '1.3rem' }}>Kg</label>
                      <span
                        style={{
                          fontSize: '1.5rem',
                          wordBreak: 'break-all',
                          fontWeight: 'bold',
                        }}
                      >
                        {' '}
                        {workOrderStats.pendingKg}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Table
              className="px-0"
              rowKey="id"
              columns={filteredColumns}
              dataSource={selectedWorkOrderBundles || []}
              pagination={{
                defaultCurrent: page,
                defaultPageSize: pagesize,
                showTotal: total => `Total ${total} items`,
                showSizeChanger: true,

                onChange: handlePageChange,
                locale: {
                  items_per_page: 'Items / Page',
                },
              }}
              onChange={handleTableChange}

              pageSizeOptions={["20", "50", "100"]}
              scroll={{ x: '600px' }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
}
